import styled from 'styled-components';
import { layout, flexbox, space } from 'styled-system';
import { colors } from '@keen.io/colors';
export var ModifiersSettings = styled.div.withConfig({
  displayName: "Appstyles__ModifiersSettings",
  componentId: "keen-query-creator__sc-1pl881y-0"
})(["&&&{display:flex;flex-wrap:wrap;gap:15px 30px;", ";}"], flexbox);
export var ModifiersItem = styled.div.withConfig({
  displayName: "Appstyles__ModifiersItem",
  componentId: "keen-query-creator__sc-1pl881y-1"
})(["&&&{", ";", ";}"], layout, space);
export var LimitContainer = styled.div.withConfig({
  displayName: "Appstyles__LimitContainer",
  componentId: "keen-query-creator__sc-1pl881y-2"
})(["&&&{max-width:100px;}"]);
export var Container = styled.div.withConfig({
  displayName: "Appstyles__Container",
  componentId: "keen-query-creator__sc-1pl881y-3"
})(["&&&{padding:25px 20px;display:flex;flex-direction:column;row-gap:15px;background-color:", ";}"], colors.white[500]);